import React, { Component } from "react";
import styled from "styled-components";
// import Icon from "react-icons/lib/io/ios-close-empty";
import {Icon} from "@vds/icons";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link } from "react-router-dom";

import arrow from "../../../assets/svgs/arrow_right_new.svg";
import CancelModal from "./CancelModal";
import { checkAMLob } from "utils/checkAMLob";
import { checkNestedObject } from "utils/checkNestedObject";
import { resetProgressIndicatorList } from "../../Layout/MainContent/DownloadAndDelete/actions";
import { media } from "utils/style";

class ProgressIndicator extends Component {
  state = {
    links: [],
    showModal: false,
    display: "block"
  };

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location;
    const { progress_links } = this.props;
    if (
      pathname !== prevProps.location.pathname ||
      (progress_links && JSON.stringify(progress_links) !== JSON.stringify(prevProps.progress_links))
    ) {
      if (pathname === "/privacy/secure/download-information" ||
        pathname === "/privacy/secure/delete" ||
        pathname === "/privacy/your-data/former-customer/download-information" ||
        pathname === "/privacy/your-data/former-customer/delete" ||
        pathname === "/privacy/your-data/former-customer/correction-request-information" ||
        pathname === "/privacy/your-data/guest/download-information" ||
        pathname === "/privacy/your-data/guest/delete") {
        if (checkNestedObject(progress_links, "links")) {
          let links = progress_links.links;
          var uniq = {};
          var arr = links;

          if (pathname === "/privacy/your-data/former-customer/download-information") {
            var arrFiltered = arr.filter(obj => !uniq[obj.label] && (uniq[obj.label] = true));
            links = arrFiltered
          }

          if (pathname === "/privacy/your-data/former-customer/delete") {
            var arrFiltered = arr.filter(obj => !uniq[obj.label] && (uniq[obj.label] = true));
            links = arrFiltered
          }

          //removal of confirmation progress for vzw delete flows.
          if (pathname === "/privacy/secure/delete" && window.reactGlobals.amLob.toLowerCase() === "vzw") {
            links = links.filter(link => link.path !== "/privacy/secure/delete-request-success");
          }

          if (window.reactGlobals.isSingleLineAcct) {
            if (pathname === "/privacy/secure/delete") {
              links = links.filter(link => link.path !== "/privacy/secure/delete-line-selection");
            } else {
              links = links.filter(link => link.path !== "/privacy/secure/device-selection");
            }
          }

          this.setState({ display: "block", links });
        }
      }

      /*
        22.16.1
        We dont want to show the line selection/progress bar for multi account customers during delete flow for vzw.
      */
      if (
        pathname === "/privacy/secure/your-data" ||
        pathname === "/privacy/your-data/former-customer" ||
        pathname === "/privacy/your-data/guest-landing" ||
        pathname === "/privacy/secure/delete-request-success" ||
        pathname === "/privacy/your-data/former-customer/verify-identity" ||
        pathname === "/privacy/your-data/guest/verify-identity" ||
        (
          pathname === "/privacy/secure/delete" &&
          (
            checkAMLob() !== "vzw" ||
            window.reactGlobals.isSingleLineAcct ||
            (!window.reactGlobals.isSingleLineAcct)
          )
        )
      ) {
        this.setState({ display: "none" });
      }

      setTimeout(() => {
        const index = this.state.links.findIndex(link => link.path === pathname);
        const updatedList = this.state.links.map((link, i) => {
          if (index !== -1) {
            if (i < index) {
              return {
                ...link,
                state: "visited"
              };
            }
            if (i > index) {
              return {
                ...link,
                state: "disabled"
              };
            }
          }
          if (link.path === pathname) {
            return {
              ...link,
              state: "active"
            };
          }
          return link;
        });

        this.setState({ links: updatedList });
      }, 1);
    }
  }

  cancelProgress = () => {
    this.setState({ showModal: false });
    if (this.props.location.state) {
      if ((this.props.location.state.serviceType &&
        this.props.location.state.serviceType === "former") ||
        (this.props.location.state.data && this.props.location.state.data.serviceType &&
          this.props.location.state.data.serviceType === "former")) {
        this.props.history.push("/privacy/your-data/former-customer");
      } else if ((this.props.location.state.serviceType &&
        this.props.location.state.serviceType === "guest") ||
        (this.props.location.state.data && this.props.location.state.data.serviceType &&
          this.props.location.state.data.serviceType === "guest")) {
        this.props.history.push("/privacy/your-data/guest-landing");
      } else {
        this.props.history.push("/privacy/secure/your-data");
      }
    } else {
      this.props.history.push("/privacy/secure/your-data");
    }
  };

  render() {
    const { modalContent, location } = this.props;
    let currentLinks = this.state.links;

    let filteredLinksLength = (currentLinks.filter(link => link.label && link.label.length > 0)).length;

    return this.state.links.length ? (
      <Container style={{ display: this.state.display }}>
        <MobileButtonContainer>
          <button
            onClick={() => this.props.history.goBack()}
            role="link"
            aria-label="go back"
            className="arrow"
          >
            <img src={arrow} aria-hidden="true" alt="" />
          </button>
          <button aria-label="cancel progress" onClick={() => this.setState({ showModal: true })}>
            <Icon name="close" aria-hidden="true" focusable="false" style={{ fontSize: "32px" }} />
          </button>
        </MobileButtonContainer>
        <div>
          <nav aria-label="progress">
            <ol>
              {this.state.links.length &&
                this.state.links.map(link => (
                  link.label ?
                    <DesktopLI
                      key={link.label}
                      state={link.state}
                      style={{ width: location.state && location.state.formerCustomerFlow && location.state.formerCustomerFlow === "delete" ? 100 / filteredLinksLength + "%" : 100 / filteredLinksLength + "%" }}
                    >
                      {/* developer Arvind aria-hidden */}
                      {link.state === "visited" ? <Hidden aria-hidden="true"> Completed: </Hidden> : null}
                      {link.state === "active" ? <Hidden aria-hidden="true"> Current: </Hidden> : null}
                      <Link
                        to={{ pathname: link.path, state: { ...this.props.location.state, confirmAuth: true } }}
                        className='progressIndicator'
                        tabIndex={link.state === "disabled" ? "-1" : "0"}
                        onFocus={(e)=>{
                          if(link.state === "disabled"){
                            e.target.blur();
                          }
                        }}
                        aria-hidden={link.state === "disabled" ? "true" : "false"}
                      >
                        {link.label}
                      </Link>
                      <div />
                    </DesktopLI> : ""
                ))}
            </ol>
          </nav>
          <DesktopCancelButton
            aria-label="cancel progress"
            onClick={() => this.setState({ showModal: true })}
          >
            Cancel
          </DesktopCancelButton>
        </div>

        {this.state.showModal && modalContent !== undefined ? (
          <CancelModal
            closeModal={() => this.setState({ showModal: false })}
            cancelProgress={this.cancelProgress}
            showCancelModal={this.state.showModal}
            modalContent={modalContent}
          />
        ) : null}
      </Container>
    ) : null;
  }
}

const mapStateToProps = ({ pageContent: { navigation_items = [] } }) => ({
  modalContent: navigation_items[0],
  progress_links: navigation_items[1]
});

export default compose(
  connect(
    mapStateToProps,
    { resetProgressIndicatorList }
  ),
  withRouter
)(ProgressIndicator);

const Container = styled.div`
  max-width: 1272px;
  margin: 0 auto;

  div {
    display: flex;
  }

  nav {
    flex-basis: 81%;
    padding: 16px 16px 0 40px;
  }

  ${media.mobile`
    div {
      padding: 0;
    }
    nav {
      flex-basis: 100%;    
      padding: 0;
    }
  `};
`;

const DesktopLI = styled.li`
  display: inline-block;

  a,
  div {
    text-decoration: none;
    font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
    display: block;
    margin: 0 2px;
    font-size: 12px;
    line-height: 16px;
  }

  a,
  div {
    ${props => {
    if (props && props.state) {
      if (props.state === "disabled") {
        return {
          pointerEvents: "none",
          opacity: ".4",
          borderBottom: "4px solid #D8DADA"
        };
      }
      return {
        borderBottom: "4px solid #EE0000"
      };
    }
    return {
      borderBottom: "4px solid #D8DADA"
    };
  }};
  }

  a {
    font-family: Verizon-NHG-eTX, Helvetica, Arial, sans-serif;
    font-weight: ${props =>
    props.state === "active" || props.state === "visited" ? '700' : "400"};
    color: ${props =>
    props.state === "active" ? '#000000' : '#6F7171'};
  }

  div {
    display: none;
  }

  ${media.mobile`
    a {
      display: none;
    }
    div {
      display: block;
    }
  `};
`;

const DesktopCancelButton = styled.button`
  background: 0;
  border: 0;
  margin: 8px 0 0 50px;
  cursor: pointer;
  text-decoration: underline;

  ${media.mobile`
    display: none;
  `};
`;

const MobileButtonContainer = styled.div`
  display: none !important;

  ${media.mobile`
    padding: 10px 10px 0 10px !important;    
    display: flex !important;
    justify-content: space-between;

    button {
      background: 0;
      border: 0;
      padding: 0;
      position: relative;
    }

    .arrow {
      height: 32px;
      width: 32px;
    }
    
    .arrow img {
      transform: rotate(180deg);
      position: absolute;
      top: 10px;
      left: 10px;
    }
  `};
`;

const Hidden = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;